// Browser-compatible base64 encoding/decoding using native APIs
export const encode = (
  str: string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _from: BufferEncoding = 'binary',
  to: BufferEncoding = 'base64',
): string => {
  if (to === 'base64') {
    return btoa(str)
  }
  return str
}

export const decode = (
  str: string,
  from: BufferEncoding = 'base64',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _to: BufferEncoding = 'binary',
): string => {
  if (from === 'base64') {
    return atob(str)
  }
  return str
}
